import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PembayaranService from "../../services/PembayaranService";
import {message} from "antd";
import {AUTH_NOMOR_PENDAFTARAN, AUTH_TOKEN} from "../../constants/AuthConstant";

export const initialState = {
    loadingPembayaran: false,
    loadingProsesBayar: false,
    loadingAktivasiDefer: false,
    bayar: false,
    showMessage:false,
    message:'',
    dataPembayaran: [],
    dataProsesBayar: [],
}


export const cekBayar = createAsyncThunk('transaksi/pembayaran/cek',async (data, { rejectWithValue }) => {
    try {
        const response = await PembayaranService.cek(localStorage.getItem(AUTH_TOKEN),localStorage.getItem(AUTH_NOMOR_PENDAFTARAN))
        //console.log(JSON.stringify(response))
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah berakhir. Silahkan login ulang!',3,function () {
            window.location.href = "auth/login";
        })
    }
})

export const postBayar = createAsyncThunk('transaksi/pembayaran/store',async (data, { rejectWithValue }) => {
    try {
        const response = await PembayaranService.bayar(localStorage.getItem(AUTH_TOKEN),{id_pendaftar:localStorage.getItem(AUTH_NOMOR_PENDAFTARAN)})
        //console.log(JSON.stringify(response))
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else {
            message.success('Mohon tunggu, akan dialihkan ke halaman pembayaran',3,function () {
                window.location.href = response.data.url;
            });
        }
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const postAktivasiDefer = createAsyncThunk('transaksi/pendaftar/aktivasidefer',async (data, { rejectWithValue }) => {
    try {
        const response = await PembayaranService.aktivasiDefer(localStorage.getItem(AUTH_TOKEN),{id_pendaftar:localStorage.getItem(AUTH_NOMOR_PENDAFTARAN)})
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else {
            message.success(response.message || 'Berhasil melakukan aktivasi defer!', 3);
            return response
        }
    } catch (err) {
        message.error(err.response?.data?.message || 'Terjadi kesalahan saat aktivasi defer!', 3)
    }
})

export const cekBayarDefer = createAsyncThunk('transaksi/pembayaran_defer/cek',async (data, { rejectWithValue }) => {
    try {
        const response = await PembayaranService.cekDefer(localStorage.getItem(AUTH_TOKEN),localStorage.getItem(AUTH_NOMOR_PENDAFTARAN))
        return response
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah berakhir. Silahkan login ulang!',3,function () {
            window.location.href = "auth/login";
        })
    }
})

export const postBayarDefer = createAsyncThunk('transaksi/pembayaran_defer/store',async (data, { rejectWithValue }) => {
    try {
        const response = await PembayaranService.bayarDefer(localStorage.getItem(AUTH_TOKEN),{id_pendaftar:localStorage.getItem(AUTH_NOMOR_PENDAFTARAN)})
        if(response.success!=true){
            message.error(response.message || 'Error',3)
        }else {
            message.success('Mohon tunggu, akan dialihkan ke halaman pembayaran',3,function () {
                window.location.href = response.data.url;
            });
        }
    } catch (err) {
        message.error(err.response?.data?.message || 'Sesi anda telah habis, silahkan login ulang!',3)
    }
})

export const pembayaranSlice = createSlice({
    name: 'pembayaran',
    initialState,
    reducers: {
        pembayaranSuccess: (state, action) => {
            state.loadingPembayaran = false
            state.bayar = action.payload.success
            state.dataPembayaran=action.payload.data
        },
        showLoadingPembayaran: (state) => {
            state.loadingPembayaran = true
        },
        showLoadingPostBayar: (state) => {
            state.loadingProsesBayar = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(cekBayar.fulfilled, (state, action) => {
                state.loadingPembayaran = false
                state.bayar = action.payload.success
                state.message = action.payload.message
                state.dataPembayaran=action.payload.data
            })
            .addCase(cekBayar.pending, (state) => {
                state.loadingPembayaran = true
            })
            .addCase(cekBayar.rejected, (state, action) => {
                state.message = action.payload.message
                state.showMessage = true
                state.loadingPembayaran = false
                state.bayar = action.payload.success
                state.dataPembayaran=action.payload.data
            })
            .addCase(postBayar.fulfilled, (state, action) => {
                state.loadingProsesBayar = false
                state.dataProsesBayar = action.payload
            })
            .addCase(postBayar.pending, (state) => {
                state.loadingProsesBayar = true
            })
            .addCase(postBayar.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loadingProsesBayar = false
                state.dataProsesBayar = action.payload
            })
            .addCase(postAktivasiDefer.fulfilled, (state, action) => {
                state.loadingAktivasiDefer = false
            })
            .addCase(postAktivasiDefer.pending, (state) => {
                state.loadingAktivasiDefer = true
            })
            .addCase(postAktivasiDefer.rejected, (state, action) => {
                state.loadingAktivasiDefer = false
            })
            .addCase(cekBayarDefer.fulfilled, (state, action) => {
                state.loadingPembayaran = false
                state.bayar = action.payload.success
                state.message = action.payload.message
                state.dataPembayaran=action.payload.data
            })
            .addCase(cekBayarDefer.pending, (state) => {
                state.loadingPembayaran = true
            })
            .addCase(cekBayarDefer.rejected, (state, action) => {
                state.message = action.payload.message
                state.showMessage = true
                state.loadingPembayaran = false
                state.bayar = action.payload.success
                state.dataPembayaran=action.payload.data
            })
            .addCase(postBayarDefer.fulfilled, (state, action) => {
                state.loadingProsesBayar = false
            })
            .addCase(postBayarDefer.pending, (state) => {
                state.loadingProsesBayar = true
            })
            .addCase(postBayarDefer.rejected, (state, action) => {
                state.loadingProsesBayar = false
            })
    },
})

export const {
   showLoadingPembayaran,
   pembayaranSuccess,
   showLoadingPostBayar
} = pembayaranSlice.actions

export default pembayaranSlice.reducer
